import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../shared/components/loader/loader.component';

@Component({
    selector: 'app-loader-demo',
    standalone: true,
    imports: [CommonModule, LoaderComponent],
    templateUrl: './loader-demo.component.html',
    styleUrls: ['./loader-demo.component.scss']
})
export class LoaderDemoComponent {
    showOverlay = false;

    toggleOverlay() {
        this.showOverlay = true;
        setTimeout(() => this.showOverlay = false, 3000);
    }
}
